module.exports = __webpack_public_path__ + "a260bd08c72b416a1283e0bf41e72cef.pdf";